import * as components from '@/components/Common'

export default function install (Vue) {
  Object.keys(components).forEach((name) => {
    Vue.component(name, components[name])
  })
}



// WEBPACK FOOTER //
// ./src/utils/components.js